import { createFileRoute } from '@tanstack/react-router';
import { fetchPurchaseOrderAttachments } from '@/api/orders';
import { OrderAttachmentsTab } from '@/app/(client)/orders/-components/OrderAttachmentsTab';
import { purchaseOrderAttachmentKeys } from '@/app/(client)/orders/-hooks/usePurchaseOrderAttachments';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/documents',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: purchaseOrderAttachmentKeys.detail(params.poId),
      queryFn: () =>
        fetchPurchaseOrderAttachments(params.poId).then(r => r.data),
    }),
  component: PurchaseOrderDocumentsRoute,
});

function PurchaseOrderDocumentsRoute() {
  const { poId } = Route.useParams();
  return (
    <div className='h-full flex flex-col'>
      <OrderAttachmentsTab orderId={poId} type='PURCHASE_ORDER' />
    </div>
  );
}
